import { useLinkClickHandler } from 'react-router-dom';
import {
  DataTableDataSearchDto,
  DetailPageDto,
  PageDto,
} from '@asset-metrix/portal-gateway-client-js';
import { DetailPageCellRenderer } from '@asset-metrix/portal-ui';
import { ICellRendererParams } from 'ag-grid-community';

import { NO_ROLE_ID } from '../../api/portalGatewayClient';
import { useStore } from '../../store';
import { buildDetailPageNavigationState } from '../../utils/detailPageLinkDisplay';

import { getDetailPageUrl } from './getDetailPageUrl';
import { useOriginHrefForDetailsPage } from './useOriginHrefForDetailsPage';

export type DetailPageCellRendererContainerProps = ICellRendererParams<
  Record<string, unknown>
> & {
  detailPageConfig?: DetailPageDto;
  pageFilter?: DataTableDataSearchDto['selection'];
  pageData?: PageDto;
};

export function DetailPageCellRendererContainer({
  detailPageConfig,
  pageFilter,
  pageData,
  ...props
}: DetailPageCellRendererContainerProps) {
  const { data } = props;
  const originHref = useOriginHrefForDetailsPage(pageData);
  const roleId = useStore((state) => state.activeUserRole?.id);

  const completeHref =
    detailPageConfig &&
    getDetailPageUrl(
      roleId ?? NO_ROLE_ID,
      detailPageConfig,
      pageFilter,
      data != null ? [data] : []
    );

  const linkColumnKey = props.column?.getColId();

  // set up click handler
  const clickHandler = useLinkClickHandler<HTMLDivElement>(completeHref ?? '', {
    state:
      detailPageConfig != null
        ? buildDetailPageNavigationState(
            originHref,
            detailPageConfig,
            linkColumnKey,
            data != null ? [data] : []
          )
        : { originHref },
  });

  return (
    <DetailPageCellRenderer
      onClick={detailPageConfig ? clickHandler : undefined}
      {...props}
    />
  );
}
